module.exports = __webpack_public_path__ + "static/media/alignment_shift.e35f30c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/alignment_shift.png
// module id = 2352
// module chunks = 0